import script from "./ChatPageCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPageCreator.vue?vue&type=script&setup=true&lang=js"

import "./ChatPageCreator.vue?vue&type=style&index=0&id=1d68b0ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d68b0ef"]])

export default __exports__